import { useEffect } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useFormStyles } from '../../styles/useFormStyles';
import { ViziTabs, ViziTab } from '../../utils/ViziTabs';
import {
  DLM_DETAILS_TABS,
  dlmDetailsTabParameters,
  dlmDetailsTabRoute,
  route,
} from '../../utils/routing';
import dashboardStore from '../../state/dashboardStore';
import { PAGES } from '../../components/main/MainComponent';
import DLMDetailsOverview from './DLMDetailsOverview';
import DLMDetailsDetails from './DLMDetailsDetails';

const DLMDetails = observer(() => {
  const formClasses = useFormStyles();
  const { dlmid } = useParams<{ dlmid: string }>();

  useEffect(() => {
    dashboardStore.appBarLabel = 'DLM Strategy Details';
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <div className={formClasses.root}>
        <div className={formClasses.verticalRoot}>
          <ViziTabs
            basePath={dlmDetailsTabParameters(dlmid)}
            tabs={Object.values(DLM_DETAILS_TABS)}
          >
            <ViziTab
              label={DLM_DETAILS_TABS.OVERVIEW}
              linkTo={dlmDetailsTabParameters(dlmid, DLM_DETAILS_TABS.OVERVIEW)}
            />
            <ViziTab
              label={DLM_DETAILS_TABS.LIST}
              linkTo={dlmDetailsTabParameters(dlmid, DLM_DETAILS_TABS.LIST)}
            />
          </ViziTabs>
          <Switch>
            <Route
              path={dlmDetailsTabRoute(DLM_DETAILS_TABS.OVERVIEW)}
              component={DLMDetailsOverview}
            />
            <Route path={dlmDetailsTabRoute(DLM_DETAILS_TABS.LIST)} component={DLMDetailsDetails} />
            <Route exact path={route(PAGES.DLM) + '/details/' + dlmid}>
              <Redirect to={dlmDetailsTabParameters(dlmid, DLM_DETAILS_TABS.OVERVIEW)} />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
});

export default DLMDetails;
